import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash/debounce";
import ListItem from "./ListItem";
import DroppableArea from "./DroppableArea";
import {
  TbLayoutSidebarLeftCollapseFilled,
  TbLayoutSidebarRightCollapseFilled,
} from "react-icons/tb";
import {
  updateL1Property,
  getL1SheetProperty,
  selectTodoDescriptionsProxy,
} from "../WorkbookSlice";
import FilterItem from "./FilterItem";
import ObjectId from "bson-objectid";
import { getSheetControls } from "../WorkbookControllingSlice";
const GRID_COLUMNS = 24;
export default function Dashboard({ currentSheet }) {
  console.log(currentSheet);
  const _id = new ObjectId().toHexString();
  const dispatch = useDispatch();
  const SheetNameArray = useSelector(selectTodoDescriptionsProxy);
  console.log(SheetNameArray);
  const dashboardSheetID = currentSheet.Sheetid;
  const droppedSheetArray =
    useSelector((state) =>
      getL1SheetProperty(state, dashboardSheetID, "SheetsArray")
    ) || [];
  const reduxheaderVisibilityArray =
    useSelector((state) =>
      getL1SheetProperty(state, dashboardSheetID, "headerVisibility")
    ) || [];

  const isAnimataionOff = useSelector(
    getSheetControls({ Sheetid: dashboardSheetID, key: "isAnimataionOff" })
  );
  console.log(isAnimataionOff);

  const leftSidebar = useRef(null);
  const droppableAreaRef = useRef(null);
  const [droppedItems, setDroppedItems] = useState(
    droppedSheetArray.length > 0 ? droppedSheetArray : []
  );
  const [sidebarWidth, setSidebarWidth] = useState(100);
  const [isAsideCollapsed, setIsAsideCollapsed] = useState(false);
  const [droppableWidth, setDroppableWidth] = useState(0);
  const [gridSize, setGridSize] = useState(25);
  console.log(gridSize);
  const [firebaseURL, setFirebaseURL] = useState(null);
  const [tab, setTab] = useState("Sheets");
  console.log(tab);
  const [headerVisibilityArray, setHeaderVisibilityArray] = useState(
    reduxheaderVisibilityArray || []
  );
  console.log(headerVisibilityArray);

  useEffect(() => {
    setDroppedItems(droppedSheetArray);
  }, []);
  const updateDimensions = () => {
    if (leftSidebar.current) {
      const { width } = leftSidebar.current.getBoundingClientRect();
      setSidebarWidth(width);
    }
    if (droppableAreaRef.current) {
      const droppableWidth =
        droppableAreaRef.current.getBoundingClientRect().width;
      setDroppableWidth(droppableWidth);
      setGridSize(droppableWidth / GRID_COLUMNS);
    }
  };
  useEffect(() => {
    updateDimensions(); // Initial dimensions
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [isAsideCollapsed]);
  // Debounced version of updateL1Property
  const debouncedUpdateL1Property = useRef(
    debounce((dashboardSheetID, droppedItems, headerVisibilityArray) => {
      console.log(droppedItems);
      dispatch(
        updateL1Property({
          SheetId: dashboardSheetID,
          key: "SheetsArray",
          value: droppedItems,
        })
      );
      dispatch(
        updateL1Property({
          SheetId: dashboardSheetID,
          key: "headerVisibility",
          value: headerVisibilityArray,
        })
      );
    }, 500)
  ).current;
  useEffect(() => {
    if (dashboardSheetID) {
      debouncedUpdateL1Property(
        dashboardSheetID,
        droppedItems,
        headerVisibilityArray
      );
    }
  }, [dashboardSheetID, droppedItems, headerVisibilityArray]);

  useEffect(() => {
    console.log(reduxheaderVisibilityArray);
    setHeaderVisibilityArray(reduxheaderVisibilityArray);
  }, []);

  const updateItemPosition = (Sheetid, x, y, quillContent) => {
    console.log(Sheetid);
    console.log(quillContent);
    setDroppedItems((prevItems) =>
      prevItems.map((item) =>
        item.Sheetid === Sheetid ? { ...item, x, y, quillContent } : item
      )
    );
  };

  const updateItemSize = (Sheetid, width, height, quillContent) => {
    console.log(quillContent);
    setDroppedItems((prevItems) =>
      prevItems.map((item) =>
        item.Sheetid === Sheetid
          ? { ...item, width, height, quillContent }
          : item
      )
    );
  };

  const handleDrop = (
    Sheetid,
    snappedX,
    snappedY,
    SheetName,
    width,
    height,
    quillContent,
    isParagraph,
    SheetVizType,
    dataSourceID
  ) => {
    console.log(quillContent);

    setDroppedItems((prevItems) => [
      ...prevItems,
      {
        Sheetid,
        x: snappedX,
        y: snappedY,
        SheetName,
        width,
        height,
        quillContent,
        isParagraph,
        SheetVizType,
        dataSourceID
      },
    ]);
  };

  const handleRemoveItem = (Sheetid) => {
    setDroppedItems((prevItems) =>
      prevItems.filter((item) => item.Sheetid !== Sheetid)
    );
  };

  const handleTitle = (e, Sheetid) => {
    // console.log(Sheetid);
    const newTitle = e.target.value; // Get the new Title from the event
    setDroppedItems((prevItems) =>
      prevItems.map((item) =>
        item.Sheetid === Sheetid ? { ...item, Title: newTitle } : item
      )
    );
  };

  return (
    <main className="w-full h-[86.2vh] flex items-center justify-between p-0">
      {isAsideCollapsed ? (
        <aside className="flex border border-gray-200 rounded h-full py-2 w-[2%] items-start justify-center">
          <TbLayoutSidebarRightCollapseFilled
            onClick={() => setIsAsideCollapsed(!isAsideCollapsed)}
          />
        </aside>
      ) : (
        <aside
          ref={leftSidebar}
          className="border border-gray-200 rounded h-full py-2 w-[12vw] min-w-[12vw]"
        >
          <div className="flex flex-col items-start justify-center gap-1 w-full px-2 font-light">
            <header className="font-medium flex items-center justify-between w-full">
              <button
                className={` ${tab === "Sheets" ? "underline" : ""}`}
                onClick={() => setTab("Sheets")}
              >
                Sheets
              </button>
              <button
                className={`${tab === "Filters" ? "underline" : ""}`}
                onClick={() => setTab("Filters")}
              >
                Filters
              </button>
              <TbLayoutSidebarLeftCollapseFilled
                onClick={() => setIsAsideCollapsed(!isAsideCollapsed)}
              />
            </header>
            {tab === "Sheets" ? (
              <>
                <div className="flex flex-col gap-1 w-full font-light">
                  {SheetNameArray.map((item) => {
                    console.log(item);
                    if (
                      item.sheetType !== "dashboard" ||
                      item.sheetType === "chart"
                    ) {
                      return (
                        <ListItem
                          key={item.ID}
                          Sheetid={item.ID}
                          isParagraph={false}
                          SheetVizType={item.VizType}
                          SheetName={item.SheetName}
                          droppableWidth={droppableWidth}
                          dataSourceID={item.dataSourceID}
                        />
                      );
                    }
                  })}
                </div>

                <div className="flex flex-col items-start justify-center gap-1 w-full font-light">
                  <h1 className="font-medium flex items-center justify-between w-full">
                    Objects
                  </h1>
                  <ListItem
                    Sheetid={_id}
                    isParagraph={true}
                    SheetName={"Paragraph"}
                    SheetVizType={"Text"}
                    droppableWidth={droppableWidth}
                    dataSourceID={null}
                  ></ListItem>
                </div>
              </>
            ) : (
              <div className="flex flex-col gap-1 w-full font-light">
                <FilterItem
                  dashboardSheetID={dashboardSheetID}
                  isFilterVisibleInDashboard={true}
                  droppedSheetsArray={droppedItems}
                  currentSheetType={"dashboard"}
                  dashboardType={"makeDashboard"}
                />
              </div>
            )}
          </div>
        </aside>
      )}

      <div ref={droppableAreaRef} className="flex-grow h-full">
        <DroppableArea
          items={droppedSheetArray}
          updateItemPosition={updateItemPosition}
          updateItemSize={updateItemSize}
          handleDrop={handleDrop}
          sidebarWidth={sidebarWidth}
          isAsideCollapsed={isAsideCollapsed}
          handleRemoveItem={handleRemoveItem}
          handleTitle={handleTitle}
          gridSize={gridSize}
          gridColumns={GRID_COLUMNS}
          dashboardSheetID={dashboardSheetID}
          headerVisibilityArray={headerVisibilityArray}
          setHeaderVisibilityArray={setHeaderVisibilityArray}
          isAnimataionOff={isAnimataionOff}
        />
      </div>
    </main>
  );
}
